import { getFormattedNumber } from 'react-phone-hooks'

const toDigits = (value?: string | number | null) =>
  String(value ?? '').replace(/\D/g, '')

export const formatPhoneNumber = (value?: string | number | null) => {
  const digits = toDigits(value)

  if (!digits) return ''

  return getFormattedNumber(digits) || `+${digits}`
}

export const toPhoneCopyValue = (value?: string | number | null) => {
  const digits = toDigits(value)

  return digits ? `+${digits}` : ''
}

export const toPhoneHref = (value?: string | number | null) => {
  const phone = toPhoneCopyValue(value)

  return phone ? `tel:${phone}` : undefined
}

/**
 * A `PhoneInput` (antd-phone-input) form value: either a raw string or the
 * component's parsed `{ countryCode, areaCode, phoneNumber }` object.
 */
export type PhoneFormValue =
  | string
  | number
  | {
      countryCode?: number | null
      areaCode?: string | null
      phoneNumber?: string | null
    }
  | null

const phoneFormValueToString = (value?: PhoneFormValue): string => {
  if (value == null) return ''
  if (typeof value === 'object') {
    return value.areaCode || value.phoneNumber
      ? [value.countryCode, value.areaCode, value.phoneNumber]
          .filter(Boolean)
          .join('')
          .trim()
      : ''
  }

  return String(value).trim()
}

/**
 * Serialize a phone form value to what the API expects — a `+`-prefixed number,
 * or `undefined` when empty. Handles both the raw-string and object shapes that
 * `PhoneInput` can emit, so callers never send the object (which the backend
 * rejects with "Not a valid string").
 */
export const normalizePhoneForSubmit = (
  value?: PhoneFormValue
): string | undefined => {
  const raw = phoneFormValueToString(value)
  if (!raw) return undefined

  return raw.startsWith('+') ? raw : `+${raw}`
}
